var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-row',[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t("expense.list.status_filter.header")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }